module.exports = __webpack_public_path__ + "fonts/ChaletComprime-HongKongEighty.abd1965f.woff";